/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Question({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M13 1.4A2.6 2.6 0 0 1 15.6 4v1.094c0 .432-.542.679-.92.469a.53.53 0 0 1-.28-.456V4A1.4 1.4 0 0 0 13 2.6H3A1.4 1.4 0 0 0 1.6 4v6A1.4 1.4 0 0 0 3 11.4h.692a.6.6 0 0 1 .6.6v1.429l1.687-1.42a2.6 2.6 0 0 1 1.673-.609h1.456a.53.53 0 0 1 .456.28c.21.378-.038.92-.47.92H7.652c-.33 0-.649.117-.901.329l-2.673 2.248a.6.6 0 0 1-.985-.46V12.6H3A2.6 2.6 0 0 1 .4 10V4A2.6 2.6 0 0 1 3 1.4zM12.356 14.2a.839.839 0 1 1 0-1.678.839.839 0 0 1 0 1.678" /><path fill="currentColor" fillRule="evenodd" d="M12.356 7.2c-.638 0-1.156.518-1.156 1.156v.22a.6.6 0 1 1-1.2 0v-.22A2.356 2.356 0 0 1 12.356 6h.13a2.226 2.226 0 0 1 1.379 3.974l-.536.423a.98.98 0 0 0-.373.77v.043a.6.6 0 0 1-1.2 0v-.044c0-.667.306-1.298.83-1.711l.536-.423a1.026 1.026 0 0 0-.636-1.832z" clipRule="evenodd" /></svg>;
}
;